<template>
  <div id="evaluation-selection">
    <!-- 仅创建人可见 -->
    <div v-show="isFounder">

      <!-- 未解答 -->
      <div class="aside-like" v-if="isUnanswered" :class="{'aside-like-collapse': !isMenu}">
        <div class="down-feedback" @click="unanswered">未解决</div>
        <div class="up-feedback" @click="answered">已解决</div>
        <div :class="[isMenu ? 'collapse' : 'more']" @click="menu">{{ isMenu ? '收起' : '更多' }}</div>
        <div class="edit" @click="$emit('editQuestion')" v-show="isMenu">编辑提问</div>
        <div class="cancel" @click="$emit('cancelQuestion')" v-show="isMenu">取消提问</div>
        <div></div>
      </div>

      <!-- 已解答 -->
      <div class="aside-like answered" v-else-if="isAnswered">
        <div class="down-feedback" @click="unanswered">未解决</div>
        <div class="up-feedback" @click="answered">已解决</div>
      </div>

      <!-- 已归档 -->
      <div class="aside-like archived" v-else-if="isArchived">
        <div class="down-feedback" v-if="unsolved" :class="{'down-active-feedback': unsolved}">未解决</div>
        <div class="up-feedback" v-else :class="{'up-active-feedback': solved}">已解决</div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'evaluationSelection',
  props: {
  },
  data () {
    return {
      isMenu: false
    }
  },
  created () {
  },
  computed: {
    ...mapGetters([
      'getQuestionDetail',
      'getUserId'
    ]),
    isFounder () {
      return this.getQuestionDetail.creatorId === this.getUserId
    },
    isUnanswered () {
      return this.getQuestionDetail.status === 0
    },
    isAnswered() {
      return this.getQuestionDetail.status === 1
    },
    isArchived() {
      return this.getQuestionDetail.status === 2
    },
    unsolved () {
      return this.getQuestionDetail.status === 2 && this.getQuestionDetail.isSolved === 0
    },
    solved () {
      return this.getQuestionDetail.status === 2 && this.getQuestionDetail.isSolved === 1
    },
    isDefineStatus () {
      return this.unsolved || this.solved
    }
  },
  methods: {
    menu () {
      this.isMenu = !this.isMenu
    },
    unanswered () {
      if (this.getQuestionDetail.status === 1) {
        this.$emit('unanswered')
      } else if (this.getQuestionDetail.status === 2) {
        return true
      } else {
        this.$message({
          showClose: true,
          message: '未解答状态下无法评估',
          type: 'warning'
        })
      }
    },
    answered () {
      if (this.getQuestionDetail.status === 1) {
        this.$emit('answered')
      } else if (this.getQuestionDetail.status === 2) {
        return true
      } else {
        this.$message({
          showClose: true,
          message: '未解答状态下无法评估',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style scoped>
  #evaluation-selection {
    width: 100%;
  }

  .aside-like {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    height: 182px;
    margin-bottom: 12px;
  }
  .answered, .archived {
    height: 90px;
  }
  .answered div {
    flex: 1;
  }
  .answered div:nth-of-type(1) {
    margin-right: 1px;
  }
  .aside-like-collapse {
    height: 90px;
  }
  .one-column {
    height: 90px;
    justify-content: center;
  }
  .two-column {
    height: 90px;
    justify-content: center;
  }
  .aside-like-feedback {
    display: flex;
    justify-content: space-between;
    height: 90px;
    margin-bottom: 12px;
  }

  .aside-like div {
    box-sizing: border-box;
    /*width: 124px;*/
    width: calc(33.333% - 1px);
    height: 90px;
    padding-top: 60px;
    padding-bottom: 13px;
    font-size: 12px;
    color: #777777;
    text-align: center;
    letter-spacing: -0.29px;
    cursor: pointer;
  }
  .aside-like-feedback div {
    box-sizing: border-box;
    /*width: 187px;*/
    width: calc(50% - 1px);
    height: 90px;
    padding-top: 60px;
    padding-bottom: 13px;
    font-size: 12px;
    color: #777777;
    text-align: center;
    letter-spacing: -0.29px;
    cursor: pointer;
  }

  .down {
    color: #CCCCCC;
    background: #fff url("../../icons/Unanswered-gray.svg") no-repeat center 18px;
    background-size: 31px;
  }
  .down-feedback{
    color: #CCCCCC;
    background: #fff url("../../icons/Unanswered-gray.svg") no-repeat center 18px;
    background-size: 31px;
  }

  .up {
    background: #fff url("../../icons/little-finger-gray.svg") no-repeat center 16px;
    background-size: 31px;
  }
  .up-feedback {
    background: #fff url("../../icons/little-finger-gray.svg") no-repeat center 16px;
    background-size: 31px;
  }
  .more {
    background: #fff url("../../icons/more-option.svg") no-repeat center 17px;
    background-size: 31px;
  }
  .collapse {
    background: #fff url("../../icons/collapse.svg") no-repeat center 17px;
    background-size: 31px;
  }
  .edit {
    background: #fff url("../../icons/edit-blue.svg") no-repeat center 17px;
    background-size: 31px;
  }
  .cancel {
    background: #fff url("../../icons/ashcan.svg") no-repeat center 18px;
    background-size: 31px;
  }
  .down-active {
    /*width: 377px !important;*/
    width: 100% !important;
    background: #fff url("../../icons/unanswered-multicolor.svg") no-repeat center 18px;
    background-size: 31px;
  }
  .up-active {
    /*width: 377px !important;*/
    width: 100% !important;
    background: #fff url("../../icons/answered.svg") no-repeat center 16px;
    background-size: 31px;
  }
  .down-active-feedback {
    /*width: 377px !important;*/
    width: 100% !important;
    color: #CCCCCC;
    background: #fff url("../../icons/unanswered-multicolor.svg") no-repeat center 18px;
    background-size: 31px;
  }

  .up-active-feedback {
    /*width: 377px !important;*/
    width: 100% !important;
    background: #fff url("../../icons/answered.svg") no-repeat center 16px;
    background-size: 31px;
  }
</style>



// WEBPACK FOOTER //
// src/components/evaluation-selection/evaluation-selection.vue